import { ORDERS_HISTORY_PAGE as dict } from '@/resources/dict'
import { HexaIcons } from './hexaIcons'

export const deliveryTypeEnum = Object.freeze({
  RECEIVE: 'RECEIVE',
  SCHEDULED: 'SCHEDULED',
  PICKUP: 'PICKUP',
  TURBO: 'TURBO',
})

export enum DeliveryType {
  RECEIVE = 'RECEIVE',
  SCHEDULED = 'SCHEDULED',
  PICKUP = 'PICKUP',
  TURBO = 'TURBO',
}

export const deliveryTypeLabel = {
  [DeliveryType.RECEIVE]: dict.deliveryTypes.receive,
  [DeliveryType.SCHEDULED]: dict.deliveryTypes.scheduled,
  [DeliveryType.PICKUP]: dict.deliveryTypes.pickup,
  [DeliveryType.TURBO]: dict.deliveryTypes.turbo,
}

export const deliveryTypeIcon = {
  RECEIVE: HexaIcons.CHECKMARK_3,
  SCHEDULED: HexaIcons.CLOCK,
  PICKUP: HexaIcons.BASKET,
  TURBO: HexaIcons.ZAP,
} as const
